<template>
  <div v-if="getPermission.ccic.view">

    <new-ccic-application-form ref="NewCcicApplicationForm"/>
    <new-ccic-container-form ref="NewCcicContainerForm"/>
    <ccic-photo-form ref="CcicPhotoForm" :on-data-refresh="doSearch"/>

    <md-dialog :md-active.sync="isPictureModalShowing">
      <md-dialog-content>
        <h3>Pictures</h3>
        <calling-api path="/api/w/ccic/photo/get">
          <view-image :key="p.photoUrl" :src="p.photoUrl" v-for="p in photos">
            <p>{{p.photoName}}</p>
            <p>{{p.refTimeStamp}}</p>
          </view-image>
        </calling-api>
      </md-dialog-content>
      <md-dialog-actions>
        <download-ccic-pictures-button :photos="photos" :zip-file-name="photoZipFileName"/>
        <md-button class="md-primary" @click="isPictureModalShowing = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-card class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-20 md-small-size-100">
            <div>
              <md-field>
                <label>Company Code</label>
                <md-input v-model="searchRequest.companyCode" @keyup.enter="doSearch"/>
              </md-field>
            </div>
            <div>
              <md-field>
                <label>IBD CCIC Status</label>
                <md-input v-model="searchRequest.ccicStatus" @keyup.enter="doSearch"/>
              </md-field>
            </div>
            <div v-if="canSearchByTeam">
              <auto-complete-master-data-multiple-select
                  label="CCIC Team"
                  v-model="searchRequest.teams"
                  :prepared-options="getCcicTeamSearchOptions"
              />
            </div>
            <div v-if="canSearchByUsers">
              <auto-complete-master-data-multiple-select
                  :prepared-options="getCcicUserSearchOptions"
                  label="Users"
                  v-model="searchRequest.users">
              </auto-complete-master-data-multiple-select>
            </div>

          </div>
          <div class="md-layout-item md-size-20 md-small-size-100">
            <div>
              <md-field>
                <label>CCIC App#</label>
                <md-input v-model="searchRequest.applicationNo" @keyup.enter="doSearch"/>
              </md-field>
            </div>
            <div>
              <datepicker v-model="searchRequest.ccicDate.startDate">
                <label>CCIC date</label>
              </datepicker>
            </div>
            <div>
              <datepicker v-model="searchRequest.cargoCutoffDate.startDate">
                <label>Cargo cut date</label>
              </datepicker>
            </div>
            <div>
              <calling-api path="/api/w/excel/generate">
                <md-card-actions>
                  <md-button v-if="items.length > 0" class="md-raised" @click="doDownloadExcel">
                    Download
                  </md-button>
                </md-card-actions>
              </calling-api>
            </div>
          </div>
          <div class="md-layout-item md-size-20 md-small-size-100">
            <div>
              <md-field>
                <label>Booking#</label>
                <md-input v-model="searchRequest.bookingNo" @keyup.enter="doSearch"/>
              </md-field>
            </div>
            <div>
              <datepicker v-model="searchRequest.ccicDate.endDate">
                <label>To</label>
              </datepicker>
            </div>
            <div>
              <datepicker v-model="searchRequest.cargoCutoffDate.endDate">
                <label>To</label>
              </datepicker>
            </div>
          </div>
          <div class="md-layout-item md-size-20 md-small-size-100">
            <div>
              <md-field>
                <label>PO</label>
                <md-input v-model="searchRequest.poNo" @keyup.enter="doSearch"/>
              </md-field>
            </div>
            <div>
              <md-field>
                <label>Yard ID</label>
                <md-input v-model="searchRequest.yardId" @keyup.enter="doSearch"/>
              </md-field>
            </div>
            <div>
              <md-field>
                <label>Supplier ID</label>
                <md-input v-model="searchRequest.supplierId" @keyup.enter="doSearch"/>
              </md-field>
            </div>
          </div>
          <div class="md-layout-item md-size-20 md-small-size-100">
            <div>
              <md-field>
                <label>IBD</label>
                <md-input v-model="searchRequest.ibd" @keyup.enter="doSearch"/>
              </md-field>
            </div>
            <div>
              <master-data-select label="State" group="State" v-model="searchRequest.state"/>
            </div>
            <div>
              <master-data-select label="Country" group="Country" v-model="searchRequest.country"/>
            </div>
            <div>
              <calling-api path="/api/w/ccic/application/search">
                <md-card-actions>
                  <md-button @click="doSearch" class="btn-search-ccic-application md-primary md-raised">Search</md-button>
                  <md-button @click="clearSearch" class="md-raised">Clear</md-button>
                </md-card-actions>
              </calling-api>
            </div>
          </div>

          <div v-if="getPermission.ccic.edit" class="md-layout-item md-size-100 md-small-size-100">
            <calling-api :paths="['/api/w/ccic/application/update','/api/w/ccic/application/delete']">
              <calling-api path="/api/w/ccic/application/create" :not-display-error="true">
                <md-button class="md-raised" :disabled="!canNew" @click="doNew">New</md-button>
                <md-button class="md-raised" :disabled="!canNewContainer" @click="doNewContainer">New Container</md-button>
                <md-button class="md-raised" :disabled="!canEdit" @click="doEdit">Edit</md-button>
                <md-button class="md-raised" :disabled="!canCancel" @click="doCancel">Cancel</md-button>
                <md-button v-if="getRole.isAcnIT" class="md-raised" :disabled="!canDelete" @click="doDelete">Delete</md-button>
                <md-button class="md-raised" :disabled="!canSave" @click="doSave">Save</md-button>
                <md-button class="md-raised" :disabled="!canEditPhotos" @click="doEditPhotos">Edit Photos</md-button>
                <md-menu md-size="small">
                  <md-button class="md-raised" md-menu-trigger>Upload</md-button>
                  <md-menu-content>
                    <md-menu-item @click="downloadUploadTempalte">Download Template</md-menu-item>
                    <md-menu-item @click="toggleUpload">Upload</md-menu-item>
                  </md-menu-content>
                </md-menu>
              </calling-api>
            </calling-api>
          </div>
        </div>
        <input type="file" class="md-hide" id="upload-ccic-application" accept=".xls,.xlsx" @change="handleUploadApplicationFileSelected"/>
      </md-card-content>

    </md-card>


    <pagination :items="items">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell w2"></th>
                    <th class="header-cell w8">CCIC App#</th>
                    <th class="header-cell w8">User</th>
                    <th class="header-cell w8">Pre Photo</th>
                    <th class="header-cell w8">Container Photo</th>
                    <th class="header-cell w8">Prohibitive</th>
                    <th class="header-cell w8">Booking No</th>
                    <th class="header-cell w8">PO#</th>
                    <th class="header-cell w8">Supplier ID</th>
                    <th class="header-cell w12">Location Group</th>
                    <th class="header-cell w15">Yard ID</th>
                    <th class="header-cell w15">IBD PU NAME</th>
                    <th class="header-cell w8">House#</th>
                    <th class="header-cell w8">IBD PU Street</th>
                    <th class="header-cell w8">City</th>
                    <th class="header-cell w8">Region</th>
                    <th class="header-cell w8">ZIP</th>
                    <th class="header-cell w8">Country</th>
                    <th class="header-cell w8">Contact person</th>
                    <th class="header-cell w8">Tel No. (CCIC)</th>
                    <th class="header-cell w8">CCIC Inspector id</th>
                    <th class="header-cell w8">CCIC Inspector name</th>
                    <th class="header-cell w8">Inspection Report</th>
                    <th class="header-cell w8">Company Code</th>
                    <th class="header-cell w8">CCIC Acce status</th>
                    <th class="header-cell w8">CCIC Est. Insp Date</th>
                    <th class="header-cell w8">Cargo Cutoff Date</th>
                    <th class="header-cell w8">IBD</th>
                    <th class="header-cell w8">PO Grade</th>
                    <th class="header-cell w8">Ctnr Qty</th>
                    <th class="header-cell w8">POL</th>
                    <th class="header-cell w8">P/L Date</th>
                    <th class="header-cell w8">ETD</th>
                    <th class="header-cell w8">Booking Ref.</th>
                    <th class="header-cell w8">Create From</th>
                    <th class="header-cell w8">Team Remark</th>
                    <th class="header-cell w8">Create Person</th>
                    <th class="header-cell w8">Create Date</th>
                    <th class="header-cell w8">Create Time</th>
                    <th class="header-cell w8">Change Person</th>
                    <th class="header-cell w8">Change Date</th>
                    <th class="header-cell w8">Change Time</th>
                    <th class="header-cell w8">Time Zone</th>
                  </tr>
                  </thead>
                </table>
              </div>
              <div class="table-body " @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                  <tr :key="item.seqNo" v-for="item in pageItems">
                    <td class="body-cell w2">
                      <md-checkbox v-model="item.selected">
                        <span v-if="hasBeenChanged(item)">*</span>
                      </md-checkbox>
                    </td>
                    <td class="body-cell w8">
                      <md-field v-if="item.editing">
                        <md-input v-model="item.applicationNo"/>
                      </md-field>
                      <template v-else>{{item.applicationNo}}</template>
                    </td>
                    <td class="body-cell w8">{{item.user}}</td>
                    <td class="body-cell w8">
                      <template v-if="item.photoCount > 0">
                        <a href="" @click.prevent="toggleItemPhoto(item)">{{item.photoCount}}
                          photos</a>
                      </template>
                      <template v-else>
                        <span>0 photos</span>
                      </template>
                    </td>
                    <td class="body-cell w8">
                      <a href="" @click.prevent="toggleContainerItemPhoto(item)">{{item.containerPhotoCount}} container
                        photos</a>
                    </td>
                    <td class="body-cell w8">{{item.prohibitive}}</td>
                    <td class="body-cell w8">
                      <md-field v-if="item.editing">
                        <md-input v-model="item.bookingNo"/>
                      </md-field>
                      <template v-else>{{item.bookingNo}}</template>
                    </td>
                    <td class="body-cell w8">
                      <md-field v-if="item.editing">
                        <md-input v-model="item.poNo"/>
                      </md-field>
                      <template v-else>{{item.poNo}}</template>
                    </td>
                    <td class="body-cell w8">{{item.supplierId}}</td>
                    <td class="body-cell w12">
                      <master-data-select v-if="item.editing" v-model="item.pickUpLocationGroup" group="CCIC_SUPPLIER_GROUPS"/>
                      <template v-else>{{item.pickUpLocationGroup}}</template>
                    </td>
                    <td class="body-cell w15">
                      <autocomplete-ccic-location-select
                          v-if="item.editing"
                          v-model="item.pickUpLocationId"
                          :group="item.pickUpLocationGroup"
                          :on-item-selected="handlePickLocationChanged(item)"
                      />
                      <template v-else>{{item.pickUpLocationId}}</template>
                    </td>
                    <td class="body-cell w15">{{item.pickUpLocationName}}</td>
                    <td class="body-cell w8"></td>
                    <td class="body-cell w8">{{item.pickUpLocation &&
                      item.pickUpLocation.yardStreet}}
                    </td>
                    <td class="body-cell w8">{{item.pickUpLocation &&
                      item.pickUpLocation.yardCity}}
                    </td>
                    <td class="body-cell w8">{{item.pickUpLocation &&
                      item.pickUpLocation.yardRegion}}
                    </td>
                    <td class="body-cell w8">{{item.pickUpLocation &&
                      item.pickUpLocation.yardPostalCode}}
                    </td>
                    <td class="body-cell w8">{{item.pickUpLocation &&
                      item.pickUpLocation.yardCountry}}
                    </td>
                    <td class="body-cell w8">{{item.pickUpLocation &&
                      item.pickUpLocation.yardContactPerson}}
                    </td>
                    <td class="body-cell w8">{{item.pickUpLocation &&
                      item.pickUpLocation.yardTelNo}}
                    </td>
                    <td class="body-cell w8">{{item.inspectorId}}</td>
                    <td class="body-cell w8">{{item.inspectorName}}</td>
                    <td class="body-cell w8"></td>
                    <td class="body-cell w8">{{item.companyCode}}</td>
                    <td class="body-cell w8">{{item.ccicStatus}}</td>
                    <td class="body-cell w8">{{item.estInspDate | date}}</td>
                    <td class="body-cell w8">{{item.cargoCutoffDate | date}}</td>
                    <td class="body-cell w8">{{item.ibd}}</td>
                    <td class="body-cell w8">{{item.poGrade}}</td>
                    <td class="body-cell w8">{{item.ctnrQty}}</td>
                    <td class="body-cell w8">{{item.pol}}</td>
                    <td class="body-cell w8">{{item.plDate | date}}</td>
                    <td class="body-cell w8">{{item.etd | date}}</td>
                    <td class="body-cell w8">{{item.bookingRef}}</td>
                    <td class="body-cell w8">{{!!item.createByWeb ? 'Web' : 'Mobile'}}</td>
                    <td class="body-cell w8">{{item.teamRemark}}</td>
                    <td class="body-cell w8">{{item.createdBy}}</td>
                    <td class="body-cell w8">{{item.createdAt | date}}</td>
                    <td class="body-cell w8">{{item.createdAt | time}}</td>
                    <td class="body-cell w8">{{item.updatedBy}}</td>
                    <td class="body-cell w8">{{item.updatedAt | date}}</td>
                    <td class="body-cell w8">{{item.updatedAt | time}}</td>
                    <td class="body-cell w8">{{item.createdAt | tz}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
  </div>
</template>

<style scoped>

</style>

<script>
  /* eslint-disable no-plusplus */
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  import toGenerateExcelRequest, { downloadExcel } from "../utils/excel";
  //import api from "../api";
  import { newAPIPost } from '../api';
  import NewCcicApplicationForm from "../components/NewCcicApplicationForm.vue";
  import CcicPhotoForm from "../components/CcicPhotoForm.vue";
  import NewCcicContainerForm from "../components/NewCcicContainerForm.vue";
  import DownloadCcicPicturesButton from "../components/DownloadCcicPicturesButton.vue";
  import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";
  import parseXls from "../utils/parseXls";

  const photoMeta = [
    {
      display: "WHOLE VIEW #1",
      key: "WV1",
      fileName: "WholeView1.JPG",
    },
    {
      display: "WHOLE VIEW #2",
      key: "WV2",
      fileName: "WholeView2.JPG",
    },
    {
      display: "WHOLE VIEW #3",
      key: "WV3",
      fileName: "WholeView3.JPG",
    },
    {
      display: "CLOSED-UP PICTURE #1",
      key: "CUP1",
      fileName: "Closed_Up Picture1.JPG",
    },
    {
      display: "CLOSED-UP PICTURE #2",
      key: "CUP2",
      fileName: "Closed_Up Picture2.JPG",
    },
    {
      display: "CLOSED-UP PICTURE #3",
      key: "CUP3",
      fileName: "Closed_Up Picture3.JPG",
    },
    {
      display: "RADIATION BASIC",
      key: "RP",
      fileName: "Radiation Picture.JPG",
    },
    {
      display: "APPLICATION REPORT",
      key: "AR",
      fileName: "Application Report.JPG",
    },
    {
      display: "INSPECTOR PICTURE",
      key: "IP",
      fileName: "Inspector Picture.JPG",
    },
    {
      display: "FACILITY PICTURE",
      key: "FP",
      fileName: "Facility Picture.JPG",
    },
    {
      display: "RADIATION FINAL",
      key: "RF",
      fileName: "RadiationFinal.JPG",
    },
    {
      display: "AVM",
      key: "AVM",
      fileName: "AVM.JPG",
    },
    {
      display: "SCALE",
      key: "SC",
      fileName: "Scale.JPG",
    },
    {
      display: "OTHER1",
      key: "PO1",
      fileName: "Other1.JPG",
    },
    {
      display: "OTHER2",
      key: "PO2",
      fileName: "Other2.JPG",
    },
    {
      display: "OTHER3",
      key: "PO3",
      fileName: "Other3.JPG",
    },
    {
      display: "OTHER4",
      key: "PO4",
      fileName: "Other4.JPG",
    },
    {
      display: "OTHER5",
      key: "PO5",
      fileName: "Other5.JPG",
    },
    {
      display: "OTHER6",
      key: "PO6",
      fileName: "Other6.JPG",
    },
    {
      display: "OTHER7",
      key: "PO",
      fileName: "Other7.JP",
    },
  ];

  const uploadCols = [
    'applicationNo',
    'poNo',
    'bookingNo',
    'pickUpLocationGroup',
    'pickUpLocationId',
  ];

  const getInitSearch = () => ({
    ccicDate: {
      startDate: null,
      endDate: null,
    },
    cargoCutoffDate: {
      startDate: null,
      endDate: null,
    },
    ccicStatus: null,
    teams: [],
    users: [],
    companyCode: null,
    applicationNo: null,
    bookingNo: null,
    poNo: null,
    yardId: null,
    supplierId: null,
    ibd: null,
    state: null,
    country: null,
  });

  export default {
    data: () => ({
      searchRequest: getInitSearch(),
      items: [],
      isPictureModalShowing: false,
      photoZipFileName: '',
      photos: [],
      usersToSearch: [],
    }),
    components: {
      AutocompleteCcicLocationSelect,
      DownloadCcicPicturesButton,
      NewCcicContainerForm,
      CcicPhotoForm,
      NewCcicApplicationForm,
    },
    watch: {
      getCcicApplications(val) {
        this.updateItems(val);
      },
      // eslint-disable-next-line
      "searchRequest.teams"() {
        this.searchRequest.users = [];
      },
    },
    computed: {
      ...mapGetters([
        'getCcicApplications',
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getPermission',
        'getUserProfile',
        'getRole',
      ]),
      getSelectedItems() {
        return _(this.items)
          .filter(it => it.selected);
      },
      getEditingItems() {
        return _(this.items)
          .filter(it => it.editing);
      },
      canCopy() {
        return this.getSelectedItems.length === 1;
      },
      canDelete() {
        return this.getSelectedItems.length === 1;
      },
      canNew() {
        return this.getEditingItems.length === 0;
      },
      canNewContainer() {
        return this.getSelectedItems.length === 1;
      },
      canEdit() {
        return true;
      },
      canEditPhotos() {
        return this.getSelectedItems.length === 1;
      },
      canCancel() {
        return this.getEditingItems.length > 0;
      },
      canSave() {
        return !!_(this.getEditingItems)
          .find(it => !!this.hasBeenChanged(it));
      },
      canSearchByTeam() {
        return this.getUserProfile.ccicRole === 'CCIC_ROLE_ADMIN' || this.getUserProfile.ccicRole === 'CCIC_ROLE_MANAGER';
      },
      getAllCcicTeamOptions() {
        return this.getMasterDataAsSelectOptionByGroup('CCIC_TEAM');
      },
      getCcicTeamSearchOptions() {
        const { ccicRole, ccicTeams } = this.getUserProfile;
        if (ccicRole === 'CCIC_ROLE_ADMIN') {
          return this.getAllCcicTeamOptions;
        }
        return this.getAllCcicTeamOptions.filter(it => _(ccicTeams)
          .contains(it.id));
      },
      getCcicUserSearchOptions() {
        const ccicUsers = this.usersToSearch;
        const selectedTeams = this.searchRequest.teams;
        if (selectedTeams.length === 0) {
          return ccicUsers;
        }
        return ccicUsers.filter(it => _.intersection(selectedTeams, it.ccicTeams).length > 0);
      },
      canSearchByUsers() {
        const { ccicRole } = this.getUserProfile;
        return ccicRole === 'CCIC_ROLE_ADMIN' || ccicRole === 'CCIC_ROLE_MANAGER';
      },
    },
    async mounted() {
      const cachedSearchRequest = this.$store.state.ccicApplication.searchRequest;
      if (cachedSearchRequest) {
        this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
      }
      this.updateItems(this.getCcicApplications);

      const { ccicRole, ccicTeams } = this.getUserProfile;

      if (ccicRole !== 'CCIC_ROLE_INSPECTOR') {
        const allCcicUsers = await this.$store.dispatch(
          'getUsersByCategory',
          {
            category: 'G',
            dontFilterDisabled: true,
          },
        );
        console.log(JSON.stringify(allCcicUsers));
        if (ccicRole === 'CCIC_ROLE_MANAGER') {
          this.usersToSearch = allCcicUsers.filter(it => _.intersection(it.ccicTeams, ccicTeams).length > 0);
        } else {
          this.usersToSearch = allCcicUsers;
        }
      }
    },
    methods: {
      doNew() {
        this.$refs.NewCcicApplicationForm.openDialog();
      },
      doNewContainer() {
        const selectedItem = this.getSelectedItems[0];
        this.$refs.NewCcicContainerForm.openDialog(selectedItem);
      },
      updateItems(itemsSource) {
        const items = JSON.parse(JSON.stringify(itemsSource));
        items.forEach((it) => {
          it.selected = false;
          it.editing = false;
        });
        this.items = items;
      },
      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },
      doSearch() {
        const { users, teams } = this.searchRequest;
        const { ccicRole } = this.getUserProfile;
        this.searchRequest.usersInTeam = [];
        if (ccicRole === "CCIC_ROLE_INSPECTOR") {
          this.searchRequest.users = [this.getUserProfile.username];
        } else if (users.length === 0 && teams.length > 0) {
          this.searchRequest.usersInTeam = this.usersToSearch
            .filter(u => _.intersection(teams, u.ccicTeams).length > 0)
            .map(it => it.id);
        } else if (users.length === 0 && teams.length === 0) {
          if (ccicRole === "CCIC_ROLE_MANAGER") {
            this.searchRequest.usersInTeam = this.usersToSearch.map(it => it.id);
          }
        }

        this.$store.dispatch('loadCcicApplications', this.searchRequest);
      },
      clearSearch() {
        _(this.$el.querySelectorAll('.searchPanel .md-field button.md-input-action.md-clear'))
          .each((it) => {
            it.click();
          });
        this.$nextTick(() => {
          this.searchRequest = getInitSearch();
        });
      },
      async toggleItemPhoto(item) {
        this.isPictureModalShowing = true;
        //const photos = await api.post('/api/w/ccic/photo/get', { applicationSeqNo: item.seqNo });
        const photos = await newAPIPost('/api/w/ccic/photo/get', { applicationSeqNo: item.seqNo });
        photos.forEach((it) => {
          it.photoName = decodeURI(it.photoUrl.replace(/.*\//g, ""));
        });
        this.photos = photos;
        this.photoZipFileName = `${item.bookingNo}_${item.poNo}.zip`;
      },
      async toggleContainerItemPhoto(item) {
        this.isPictureModalShowing = true;
        //const photos = (await api.post('/api/w/ccic/photo/get', {
        const photos = (await newAPIPost('/api/w/ccic/photo/get', {
          applicationSeqNo: item.seqNo,
          forContainersInApplication: true,
        }));
        photos.forEach((it) => {
          it.photoName = `${it.containerNo}-${decodeURI(it.photoUrl.replace(/.*\//g, ""))}`;
        });
        this.photos = photos;
        this.photoZipFileName = `${item.bookingNo}_${item.poNo}_containers.zip`;
      },
      doDownloadExcel() {
        const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
          'IBD.xls',
          1,
        );
        request.heads = _(request.heads)
          .take(41);

        request.rows = _(this.items)
          .map(item => [
            item.applicationNo,
            item.user,
            `${item.photoCount} photos`,
            `${item.containerPhotoCount} photos`,
            item.bookingNo,
            item.poNo,
            item.supplierId,
            item.pickUpLocationId,
            item.pickUpLocationName,
            '',
            item.pickUpLocationGroup,
            _.lookup(item, 'pickUpLocation.yardStreet'),
            _.lookup(item, 'pickUpLocation.yardCity'),
            _.lookup(item, 'pickUpLocation.yardRegion'),
            _.lookup(item, 'pickUpLocation.yardPostalCode'),
            _.lookup(item, 'pickUpLocation.yardCountry'),
            _.lookup(item, 'pickUpLocation.yardContactPerson'),
            _.lookup(item, 'pickUpLocation.yardTelNo'),
            item.inspectorId,
            item.inspectorName,
            '',
            item.companyCode,
            item.ccicStatus,
            item.estInspDate,
            item.cargoCutoffDate,
            item.ibd,
            item.poGrade,
            item.ctnrQty,
            item.pol,
            dateFormat.date(item.plDate),
            item.etd,
            item.bookingRef,
            !!item.createByWeb ? 'Web' : 'Mobile',
            item.teamRemark,
            item.createdBy,
            dateFormat.date(item.createdAt),
            dateFormat.time(item.createdAt),
            item.updatedBy,
            dateFormat.date(item.updatedAt),
            dateFormat.time(item.updatedAt),
            dateFormat.tz(item.createdAt),
          ]);

        this.$store.dispatch('generateExcel', request)
          .then((res) => {
            window.open(res.url, 'blank');
          });
      },
      hasBeenChanged(item) {

        console.log("test");
        const lhs = _(this.getCcicApplications)
          .find(it => it.seqNo === item.seqNo);
        if (lhs) {
          return (lhs.poNo !== item.poNo)
            || (lhs.bookingNo !== item.bookingNo)
            || (lhs.pickUpLocationId !== item.pickUpLocationId)
            || (lhs.applicationNo !== item.applicationNo);
        }
        return false;
      },
      doEdit() {
        this.getSelectedItems.forEach((it) => {
          it.editing = true;
        });
      },
      doCancel() {
        const editingItem = this.getEditingItems[0];
        const lhs = _(this.getCcicApplications)
          .find(it => it.seqNo === editingItem.seqNo);
        Object.assign(editingItem, lhs);
        editingItem.editing = false;
      },
      handlePickLocationChanged(item) {
        return (pickupLocation) => {
          if (pickupLocation) {
            item.pickUpLocationId = pickupLocation.tagId;
            item.pickUpLocationName = pickupLocation.tagName;
            item.pickUpLocation = pickupLocation;
          } else {
             //item.pickUpLocationId = null;
            // item.pickUpLocationName = null;
            // item.pickUpLocation = null;
          }
        };
      },
      async doSave() {
        if (_(this.getEditingItems)
          .find(it => !it.pickUpLocationId)) {
          window.alert('Pickup location is required');
          return;
        }

        //await Promise.all(this.getEditingItems.map(it => api.post('/api/w/ccic/application/update', it)));
        await Promise.all(this.getEditingItems.map(it => newAPIPost('/api/w/ccic/application/update', it)));
        this.doSearch();
      },
      async doDelete() {
        const selectedItem = this.getSelectedItems[0];
        const { user, seqNo } = selectedItem;
        if (window.confirm('Delete Application?')) {
          //await api.post('/api/w/ccic/application/delete', {
          await newAPIPost('/api/w/ccic/application/delete', {
            user,
            seqNo,
          });
          this.doSearch();
        }
      },
      doEditPhotos() {
        const selectedItem = this.getSelectedItems[0];
        this.$refs.CcicPhotoForm.openDialog(
          `${selectedItem.bookingNo}_${selectedItem.poNo}.zip`,
          selectedItem.seqNo,
          "CCIC_APPLICATION",
          photoMeta,
          { applicationSeqNo: selectedItem.seqNo },
        );
      },
      downloadUploadTempalte() {
        downloadExcel(
          [
            uploadCols,
            [
              'A01',
              'P01',
              'B01',
              'SUPPLIER_US',
              '1010005',
            ],
          ],
          'CCIC_Application',
          'CCIC_Application.xlsx',
        );
      },
      toggleUpload() {
        this.$el.querySelector('#upload-ccic-application')
          .click();
      },
      handleUploadApplicationFileSelected(e) {
        const { files } = e.target;
        if (files && files[0]) {
          parseXls(files[0])
            .then((data) => {
              const headCols = data[0];
              if (!_.isEqual(headCols, uploadCols)) {
                window.alert('not a valid format');
                return;
              }

              headCols.push('upload result');

              data.shift();

              console.log(JSON.stringify(data));
              this.$el.querySelector('#upload-ccic-application').value = '';

              const allApiCalls = _(data)
                .chain()
                .map((it) => {
                  let i = 0;
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(
                      '/api/w/ccic/application/create',
                      {
                        applicationNo: it[i++],
                        poNo: it[i++],
                        bookingNo: it[i++],
                        pickUpLocationGroup: it[i++],
                        pickUpLocationId: it[i++],
                        user: this.getUserProfile.username,
                      },
                    )
                      .then(() => {
                        it.push('ok');
                        resolve(it);
                      })
                      .catch((err) => {
                        it.push(err.messages.join(';'));
                        resolve(it);
                      });
                  });
                })
                .value();

              Promise.all(allApiCalls)
                .then((results) => {
                  const resultData = [];
                  resultData.push(headCols);
                  _(results)
                    .each(it => resultData.push(it));

                  downloadExcel(
                    resultData,
                    'CCIC_Application',
                    'CCIC_Application-UploadResult.xlsx',
                  );
                });
            });
        }
      },
    },
  };

</script>
